webpackJsonp([39,66,250,251],{

/***/ 1275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    methods: {
        toast: function toast() {
            this.$buefy.toast.open('Something happened');
        },
        success: function success() {
            this.$buefy.toast.open({
                message: 'Something happened correctly!',
                type: 'is-success'
            });
        },
        danger: function danger() {
            this.$buefy.toast.open({
                duration: 5000,
                message: 'Something\'s not good, also I\'m on bottom',
                position: 'is-bottom',
                type: 'is-danger'
            });
        }
    }
});

/***/ }),

/***/ 1276:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('button', {
    staticClass: "button is-medium",
    on: {
      "click": _vm.toast
    }
  }, [_vm._v("\n            Launch toast (default)\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "button is-medium is-success",
    on: {
      "click": _vm.success
    }
  }, [_vm._v("\n            Launch toast (custom)\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "button is-medium is-danger",
    on: {
      "click": _vm.danger
    }
  }, [_vm._v("\n            Launch toast (custom)\n        ")])])
},staticRenderFns: []}

/***/ }),

/***/ 1565:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_toast__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__variables_toast__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__examples_ExSimple__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__examples_ExSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__examples_ExSimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__raw_loader_examples_ExSimple__ = __webpack_require__(1566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__raw_loader_examples_ExSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__raw_loader_examples_ExSimple__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            api: __WEBPACK_IMPORTED_MODULE_0__api_toast__["default"],
            variables: __WEBPACK_IMPORTED_MODULE_1__variables_toast__["default"],
            ExSimple: __WEBPACK_IMPORTED_MODULE_2__examples_ExSimple___default.a,
            ExSimpleCode: __WEBPACK_IMPORTED_MODULE_3__raw_loader_examples_ExSimple___default.a,
            outsideVueInstance: '\n                import { ToastProgrammatic as Toast } from \'buefy\'\n                Toast.open(\'Toasty!\')'
        };
    }
});

/***/ }),

/***/ 1566:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <button class=\"button is-medium\" @click=\"toast\">\n            Launch toast (default)\n        </button>\n\n        <button class=\"button is-medium is-success\" @click=\"success\">\n            Launch toast (custom)\n        </button>\n\n        <button class=\"button is-medium is-danger\" @click=\"danger\">\n            Launch toast (custom)\n        </button>\n    </section>\n</template>\n\n<script>\n    export default {\n        methods: {\n            toast() {\n                this.$buefy.toast.open('Something happened')\n            },\n            success() {\n                this.$buefy.toast.open({\n                    message: 'Something happened correctly!',\n                    type: 'is-success'\n                })\n            },\n            danger() {\n                this.$buefy.toast.open({\n                    duration: 5000,\n                    message: `Something's not good, also I'm on bottom`,\n                    position: 'is-bottom',\n                    type: 'is-danger'\n                })\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1567:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("They have a slightly transparency and are queued to not confuse the user.")]), _vm._v(" "), _c('p', [_c('small', [_c('b', [_vm._v("Note:")]), _vm._v(" They queue with "), _c('router-link', {
    attrs: {
      "to": "/documentation/snackbar"
    }
  }, [_vm._v("Snackbars")]), _vm._v(" as well.")], 1)])]), _vm._v(" "), _c('Example', {
    attrs: {
      "title": "From inside Vue instance",
      "component": _vm.ExSimple,
      "code": _vm.ExSimpleCode
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "title": "From outside Vue instance"
    }
  }, [_c('p', [_vm._v("You can use it on Vuex or VueRouter using this syntax:")]), _vm._v(" "), _c('CodeView', {
    attrs: {
      "lang": "javascript",
      "code": _vm._f("pre")(_vm.outsideVueInstance),
      "expanded": ""
    }
  })], 1), _vm._v(" "), _c('ApiView', {
    attrs: {
      "data": _vm.api
    }
  }), _vm._v(" "), _c('VariablesView', {
    attrs: {
      "data": _vm.variables
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 334:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ([{
    props: [{
        name: '<code>type</code>',
        description: 'Type (color) of the toast',
        type: 'String',
        values: '<code>is-white</code>, <code>is-black</code>, <code>is-light</code>,\n                    <code>is-dark</code>, <code>is-primary</code>, <code>is-info</code>, <code>is-success</code>,\n                    <code>is-warning</code>, <code>is-danger</code>,\n                    and any other colors you\'ve set in the <code>$colors</code> list on Sass',
        default: '<code>is-dark</code>'
    }, {
        name: '<code>message</code>',
        description: 'Message text',
        type: 'String',
        values: '—',
        default: '—'
    }, {
        name: '<code>position</code>',
        description: 'Which position the toast will appear',
        type: 'String',
        values: '<code>is-top-right</code>, <code>is-top</code>, <code>is-top-left</code>, <code>is-bottom-right</code>, <code>is-bottom</code>, <code>is-bottom-left</code>',
        default: '<code>is-top</code>'
    }, {
        name: '<code>duration</code>',
        description: 'Visibility duration in milliseconds',
        type: 'Number',
        values: '—',
        default: '<code>2000</code>'
    }, {
        name: '<code>queue</code>',
        description: 'If should queue with others notices (snackbar/toast/notification)',
        type: 'Boolean',
        values: '—',
        default: '<code>true</code>'
    }, {
        name: '<code>container</code>',
        description: 'DOM element the toast will be created on. Note that this also changes the <code>position</code> of the toast from <code>fixed</code> to <code>absolute</code>. Meaning that the container should be <code>fixed</code>. Also note that this will override the <code>defaultContainerElement</code> if you specified it in your Buefy Constructor Options. See Constructor options for more details.',
        type: 'String',
        values: '—',
        default: '<code>body</code>'
    }]
}]);

/***/ }),

/***/ 335:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ([{
    name: '<code>$toast-border-radius</code>',
    default: '<code>2em</code>'
}, {
    name: '<code>$toast-opacity</code>',
    default: '<code>0.92</code>'
}, {
    name: '<code>$toast-box-shadow</code>',
    default: '<code>0 1px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04)</code>'
}]);

/***/ }),

/***/ 336:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1275),
  /* template */
  __webpack_require__(1276),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 391:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1565),
  /* template */
  __webpack_require__(1567),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/39.6ebd6374389c80808a58.js